import { useRef, useState } from "react";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { UseGeneratePdfProps } from "./types";

/**
 * @returns viewRef -> Make sure that in the view where you have the ref, add the parameter collapsable={false} to avoid an error on Android.
 */
export const useGeneratePdf = (
  { documentTitle }: UseGeneratePdfProps = {
    documentTitle: `document-${Date.now()}`
  }
) => {
  const viewRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleCaptureAndGeneratePDF = async () => {
    try {
      setIsLoading(true);
      if (!viewRef.current) {
        console.error("No view to capture");
        return;
      }

      const canvas = await html2canvas(viewRef.current, {
        scrollY: typeof window !== "undefined" ? -window.scrollY : 0,
        useCORS: true,
        allowTaint: true
      });
      const imgData = canvas.toDataURL("image/jpeg");

      const imageWidth = canvas.width;
      const imageHeight = canvas.height;

      const pdf = new jsPDF({
        orientation: imageWidth > imageHeight ? "landscape" : "portrait",
        unit: "px",
        format: [imageWidth, imageHeight]
      });

      pdf.addImage(imgData, "JPEG", 0, 0, imageWidth, imageHeight);
      pdf.save(`${documentTitle}.pdf`);
    } catch (error) {
      console.error("Error to generate PDF", error);
    } finally {
      setIsLoading(false);
    }
  };

  return { viewRef, handleCaptureAndGeneratePDF, isLoading };
};
